var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
var AchooModalComponent = /** @class */ (function (_super) {
    __extends(AchooModalComponent, _super);
    function AchooModalComponent() {
        return _super.call(this) || this;
    }
    return AchooModalComponent;
}(AchooPopupComponent));
export { AchooModalComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/achoo-modal/achoo-modal.component.ts.pre-build-optimizer.js